import {RcfaComplianceQuickSelectionIds} from '@domain/rcfa'
import {usePlantViewState} from '@hconnect/common/hooks'
import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

const RcfaCompliancePageParams = {
  PLANT_VIEW: 'plantView',
  TIME_RANGE: 'timeRange'
}

export const useRcfaCompliancePageState = () => {
  const plantViewState = usePlantViewState(RcfaCompliancePageParams.PLANT_VIEW)
  const timeRangeState = useTimeRangeParam()

  return {...plantViewState, ...timeRangeState}
}

const useTimeRangeParam = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const timeRangeParam = getUrlParam(searchParams, RcfaCompliancePageParams.TIME_RANGE)

  const setTimeRangeParam = (value: string) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, RcfaCompliancePageParams.TIME_RANGE, value)
    setSearchParams(newParams)
  }

  return {
    timeRange: timeRangeParam ?? RcfaComplianceQuickSelectionIds.YEAR_TO_DATE_YTD,
    setTimeRange: setTimeRangeParam
  }
}
